import React, { useEffect, memo, FC, CSSProperties } from 'react';

import {
  Handle,
  Position,
  NodeProps,
  Connection,
  Edge,
} from 'react-flow-renderer';
import { useTranslation } from 'react-i18next';
import { DiamondBox } from '../Shapes';

const targetHandleStyle: CSSProperties = {
  background: 'transparent',
  border: 'none',
  left: -15,
};
const sourceHandleStyle: CSSProperties = {
  background: 'transparent',
  right: -580,
  // border: 'none',
};

const onConnect = (params: Connection | Edge) =>
  console.log('handle onConnect', params);

const Q6: FC<NodeProps> = ({ data, isConnectable }) => {
  const { t } = useTranslation();
  const [isEdgePathObserved, setIsEdgePathObserved] = React.useState(false);

  const observeEdgePaths = () => {
    // 创建观察器实例
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        const target = mutation.target as HTMLElement;
        if (target.classList.contains('my_react-flow__edge-path')) {
          const strokeColor = target.style.color;
          if (strokeColor === 'red') {
            // 注意颜色格式是rgb
            // console.log('发现红色路径:', {
            //   element: target,
            //   d: target.getAttribute('d'), // 获取路径数据
            //   style: target.getAttribute('style'),
            // });
            setIsEdgePathObserved(true);
          } else {
            setIsEdgePathObserved(false);
          }
        }
      });
    });

    // 配置观察选项
    const config = {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['style'],
    };

    // 初始检查已存在的路径
    document.querySelectorAll('.my_react-flow__edge-path').forEach((path) => {
      observer.observe(path, config);
    });

    // 动态检测新增路径（适用于异步加载情况）
    const checkNewPaths = () => {
      document.querySelectorAll('.my_react-flow__edge-path').forEach((path) => {
        if (!(path as any)._observed) {
          observer.observe(path, config);
          (path as any)._observed = true;
        }
      });
    };

    // 每500ms检查一次新路径（根据实际情况调整频率）
    const intervalId = setInterval(checkNewPaths, 500);

    // 清理函数
    return () => {
      observer.disconnect();
      clearInterval(intervalId);
    };
  };

  useEffect(() => {
    const cleanup = observeEdgePaths();
    return cleanup; // 组件卸载时停止监听
  }, []);

  return (
    <DiamondBox>
      <Handle
        type="target"
        id="Q6-Target-L"
        position={Position.Left}
        style={targetHandleStyle}
        onConnect={onConnect}
      />
      <div className="txt">
        <span className="redBold">Q6.</span>
        <div dangerouslySetInnerHTML={{ __html: t('Q6') }} />
      </div>
      <Handle
        type="source"
        position={Position.Right}
        style={sourceHandleStyle}
        onConnect={onConnect}
      >
        <div
          style={{
            color: isEdgePathObserved ? 'red' : 'black',
            width: '566px',
            borderTop: isEdgePathObserved ? '2px solid' : '1px solid',
            margin: isEdgePathObserved ? '2px 0 0 -559px' : '2.5px 0 0 -559px',
          }}
        ></div>
      </Handle>
    </DiamondBox>
  );
};

export default memo(Q6);
